import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

const BadgeCodeBudget = ({ code = "" }) => {
    return (
        <Wrapper vAlign="center" hAlign="center" gap="gap.small">
            <Ball />
            <CodeBudget content={code} />
        </Wrapper>
    );
};

export default BadgeCodeBudget;

const CodeBudget = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-3, #fff);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;

const Ball = styled.div`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: white;
    z-index: 1;
`;

const Wrapper = styled(Flex)`
    padding: 6px 8px 6px 0px;
    background-color: #3d3e78;
    border-radius: 0px 4px 4px 0px;
    position: relative;
    ::before {
        background-color: inherit;
        content: "";
        width: 16px;
        position: absolute;
        bottom: 0px;
        left: -15px;
        top: 0px;
        border-radius: 150px 0px 0px 150px;
    }
`;
